import { render, staticRenderFns } from "./singleCrosstab.vue?vue&type=template&id=202eaedd&scoped=true"
import script from "./singleCrosstab.vue?vue&type=script&lang=js"
export * from "./singleCrosstab.vue?vue&type=script&lang=js"
import style0 from "./singleCrosstab.vue?vue&type=style&index=0&id=202eaedd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202eaedd",
  null
  
)

export default component.exports